export default function FadeIn () {
  setTimeout(() => {
    const FADEIN_ELEMENTS = document.querySelectorAll('.fade-in')
    if (FADEIN_ELEMENTS.length > 0) {
      for (let i = 0; i < FADEIN_ELEMENTS.length; i++) {
        FADEIN_ELEMENTS[i].classList.add('fade-in__completed')
      }
    }
  }, 50)
}
